import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "flowbite-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import AddWalletBottomSheet from "./AddWalletBottomSheet";

function AddWallet({ onCreate, sideBar = false }) {
  const { t } = useTranslation();
  const [showCreateWalletSheet, setShowCreateWalletSheet] = useState(false);

  const showCreateSheet = () => {
    setShowCreateWalletSheet(true);
  };

  return (
    <>
      <div class={`snap-center shrink-0 w-full ${sideBar ? "lg:w-full" : "lg:w-[25rem]"}`}>
        <div className="bg-card rounded-2xl mx-1 text-white p-[1rem] cursor-pointer border-2 border-dashed border-gray-400 dark:border-gray-600 flex h-full items-center justify-center" onClick={showCreateSheet}>
          <Button className="bg-card p-4 gap-2 items-center flex rounded-2xl">
            <FontAwesomeIcon icon={faPlus} className="card-icon" />
            <span className="font-medium text-base">{t("ADD_WALLET")}</span>
          </Button>
        </div>
      </div>

      {
        showCreateWalletSheet && (
          <AddWalletBottomSheet onCreate={() => {
            setShowCreateWalletSheet(false)
            onCreate()
          }} onClose={() => {
            setShowCreateWalletSheet(false)
          }} />
        )
      }
    </>
  );
}

export default AddWallet;
